<div class="container">
  <div class="d-none d-lg-block back-button-padding">
    <button class="back-btn border-0 d-flex align-items-center justify-content-center" (click)="location.back()">
      <span class="material-icons text-white">arrow_back_ios_new</span>
    </button>
  </div>
</div>
<!-- Points Summary -->
<div class="container">
  <fgb-points-summary-bar [marketplaceItemGroup]="marketplaceItemType().group"></fgb-points-summary-bar>
</div>

<fgbcl-marketplace-details-v2 [itemId]="id"></fgbcl-marketplace-details-v2>
